<template>
  <div class="w-full px-0 bg-white rounded-lg dark:bg-transparent">
    <!-- Desktop: Animated Logos -->

    <!-- <div :class="{ 'opacity-0': !loading }" class="items-center overflow-hidden w-full relative h-14 hidden lg:block">
      <div class="flex whitespace-nowrap absolute left-0 top-0">
        <img
          v-for="(provider, index) in providers"
          :key="index"
          :src="provider.img"
          :alt="provider.name"
          class="h-5 mr-4"
        />
      </div>
    </div> -->
    <!-- Loading Indicator -->
    <div class="flex items-center w-full">
      <!-- <Spinner v-show="loading" class="hidden md:block"></Spinner> -->
      <div class="flex-grow">
        <!-- Progress Bar -->
        <div :class="{ 'opacity-0': !loading }" class="w-full bg-gray-200 rounded-full h-2 dark:bg-gray-700 mb-4">
          <div :style="{ width: `${progressPercentage}%` }" class="bg-Tourscanner_blue-source h-2 rounded-full"></div>
        </div>
        <div class="flex flex-row justify-between items-center">
          <p
            v-if="loading"
            class="text-xl block font-medium text-grey mb-0 md:mb-5 text-gray-600 dark:text-gray-300 leading-tight"
          >
            {{
              t('({checkedProviders}/{totalProviders}) checking {currentProvider}...', {
                currentProvider: currentProvider,
                checkedProviders: checkedProviders,
                totalProviders: totalProviders,
              })
            }}
          </p>
          <p
            v-else
            class="text-xl block font-medium text-grey mb-0 md:mb-5 text-gray-600 dark:text-gray-300 leading-tight"
          >
            {{ $t('Activities found:') }} {{ localizedNumber(foundActivities, 'decimal') }}
          </p>
          <!-- Mobile: Changing logo in top right -->

          <div
            :class="{ 'opacity-0': !loading }"
            class="w-20 h-10 bg-contain bg-center bg-no-repeat"
            :style="{ backgroundImage: 'url(' + currentLogo.img + ')' }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';

const { t } = useI18n();

const props = defineProps({
  restartTrigger: {
    type: Number,
    default: 0,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  foundActivities: {
    type: Number,
    default: 0,
  },
});

// List of providers
const providers = ref([
  { name: 'Musement', img: '/img/providers/partner-home-musement-new.svg' },
  { name: 'Viator', img: '/img/providers/partner-home-viator-new.svg' },
  { name: 'Tiqets', img: '/img/providers/partner-home-tiqets-new.svg' },
  { name: 'Klook', img: '/img/providers/partner-home-klook-new.svg' },
  { name: 'Civitatis', img: '/img/providers/partner-home-civitatis-new.svg' },
  { name: 'GetYourGuide', img: '/img/providers/partner-home-gyg-new.svg' },
  { name: 'Manawa', img: '/img/providers/partner-home-manawa-new.svg' },
  { name: 'Headout', img: '/img/providers/partner-home-headout-new.svg' },
  { name: 'Fever', img: '/img/providers/partner-home-fever-new.svg' },
  { name: 'ClickAndBoat', img: '/img/providers/partner-home-civitatis-new.svg' },
  { name: 'Musement', img: '/img/providers/partner-home-musement-new.svg' },
  { name: 'Viator', img: '/img/providers/partner-home-viator-new.svg' },
  { name: 'Tiqets', img: '/img/providers/partner-home-tiqets-new.svg' },
  { name: 'Klook', img: '/img/providers/partner-home-klook-new.svg' },
  { name: 'Civitatis', img: '/img/providers/partner-home-civitatis-new.svg' },
  { name: 'GetYourGuide', img: '/img/providers/partner-home-gyg-new.svg' },
  { name: 'Manawa', img: '/img/providers/partner-home-manawa-new.svg' },
  { name: 'Headout', img: '/img/providers/partner-home-headout-new.svg' },
  { name: 'Fever', img: '/img/providers/partner-home-fever-new.svg' },
  { name: 'ClickAndBoat', img: '/img/providers/partner-home-civitatis-new.svg' },
  { name: 'GetYourGuide', img: '/img/providers/partner-home-gyg-new.svg' },
  { name: 'Manawa', img: '/img/providers/partner-home-manawa-new.svg' },
  { name: 'Headout', img: '/img/providers/partner-home-headout-new.svg' },
  { name: 'Fever', img: '/img/providers/partner-home-fever-new.svg' },
]);

const currentLogo = ref(providers.value[0]);

// Duplicate providers to make the animation smoother
providers.value = [...providers.value, ...providers.value];

const totalProviders = providers.value.length / 2;
const checkedProviders = ref(0);
const currentProvider = ref(providers.value[0].name);
const progressPercentage = ref(0);

const updateProgress = () => {
  if (checkedProviders.value < totalProviders) {
    checkedProviders.value++;
    const currentIndex = checkedProviders.value % totalProviders;
    currentProvider.value = providers.value[currentIndex].name;
    currentLogo.value = providers.value[currentIndex];
    progressPercentage.value = (checkedProviders.value / totalProviders) * 100;

    const randomDelay = Math.random() * 400 + 50;
    setTimeout(updateProgress, randomDelay);
  }
};

const resetProgress = () => {
  checkedProviders.value = 0;
  currentProvider.value = providers.value[0].name;
  progressPercentage.value = 0;
  updateProgress();
};

watch(
  () => props.restartTrigger,
  () => {
    resetProgress();
  },
);

onMounted(() => {
  updateProgress();
});
</script>

<style scoped>
.loader {
  border: 4px solid #f3f3f3;
  border-radius: 50%;
  border-top: 4px solid #3498db;
  width: 24px;
  height: 24px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

.animate-marquee {
  animation: marquee 20s linear infinite;
}
</style>
